import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SignIn from "./views/SignIn.js";
import SignInRootUser from "./views/SignInRootUser.js";
import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { ToastContainer } from "react-toastify";
import UserManagmentPage from "./views/UserManagmentPage.js";
import BusinessHubSectionPage from "./views/BusinessHubSectionPage.js";
import AddUser from "./components/AddUser.js";
import AddRole from "./components/AddRole.js";
import EditUserDetails from "./components/EditUserDetails.js";
import EditUserRole from "./components/EditUserRole.js";
import RegComp from "./components/RegComp.js";
import AddDeliveryComp from "./components/AddDeliveryComp.js";
import AddIndepDriver from "./components/AddIndepDriver.js";
import AddVendor from "./components/AddVendor.js";
import AddRelatedBusiness from "./components/AddRelatedBusiness.js";
import AddBranch from "./components/AddBranch.js";
import RelatedCompData from "./components/RelatedCompData.js";
import ViewCompAttach from "./components/ViewCompAttach.js";
import QrCodeManagement from "./components/QrCodeManagement.js";
import SingleQRcode from "./components/SingleQRcode.js";
import BulkQrs from "./components/BulkQrs.js";
import ProductSubmissionPage from "./views/ProductSubmissionPage.js";
import PromotionsAndMarketingPage from "./views/PromotionsAndMarketingPage.js";
import VendorLogoLoader from "./components/VendorLoadingOverlay.js";
import DeleveryManagment from "./components/DeleveryManagment.js";
import {
  getIsGlobalLoading,
  subscribeToGlobalLoading,
} from "./utils/globalLoading.js";

import ProductCatalogPage from "./views/ProductCatalogPage.js";
import ProductCatalogDetailsPage from "./views/ProductCatalogDetailsPage.js";
import { getRouteForActiveKey } from "./utils/businessHubRoutes.js";

function LegacyPromotionRedirect({ targetView }) {
  const location = useLocation();
  const params = new URLSearchParams();

  if (targetView) {
    params.set("view", targetView);
  }

  if (targetView === "promotion-details") {
    const pid = location.state?.PID;
    const mode = location.state?.Mode ? "edit" : "view";

    if (pid) params.set("pid", String(pid));
    params.set("mode", mode);
  }

  if (targetView === "featured-placement") {
    const productOfferId = location.state?.productOfferId;
    const mode = location.state?.Mode ? "edit" : "view";

    if (productOfferId) {
      params.set("productOfferId", String(productOfferId));
    }
    params.set("mode", mode);
  }

  const query = params.toString();
  return (
    <Navigate
      replace
      to={`/promotions-and-marketing${query ? `?${query}` : ""}`}
    />
  );
}

function App() {
  const [isGlobalLoading, setIsGlobalLoading] = useState(getIsGlobalLoading());

  useEffect(() => subscribeToGlobalLoading(setIsGlobalLoading), []);

  return (
    <div className="App">
      <>
        <ToastContainer />
        <VendorLogoLoader isVisible={isGlobalLoading} />
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/add-vendor" element={<AddVendor />} />
          <Route path="/related-comp-data" element={<RelatedCompData />} />
          <Route
            path="/product-catalog/details"
            element={<ProductCatalogDetailsPage />}
          />
          <Route path="/product-catalog" element={<ProductCatalogPage />} />
          <Route
            path="/view-company-attachements"
            element={<ViewCompAttach />}
          />
          <Route
            path="/add-related-business"
            element={<AddRelatedBusiness />}
          />
          <Route path="/Qr-code-management" element={<QrCodeManagement />} />
          <Route path="/create-bulk-qr-code" element={<BulkQrs />} />
          <Route path="/create-single-qr-code" element={<SingleQRcode />} />
          <Route path="/add-indep-driver" element={<AddIndepDriver />} />
          <Route path="/add-Branch" element={<AddBranch />} />
          <Route path="/signInRootUser" element={<SignInRootUser />} />
          <Route path="/register-company" element={<RegComp />} />
          <Route path="/add-delivery-comp" element={<AddDeliveryComp />} />
          <Route path="/user-management" element={<UserManagmentPage />} />
          <Route
            path={getRouteForActiveKey("A")}
            element={<BusinessHubSectionPage activeKey="A" />}
          />
          <Route
            path={getRouteForActiveKey("B")}
            element={<BusinessHubSectionPage activeKey="B" />}
          />
          <Route
            path={getRouteForActiveKey("D")}
            element={<BusinessHubSectionPage activeKey="D" />}
          />
          <Route
            path={getRouteForActiveKey("E")}
            element={<BusinessHubSectionPage activeKey="E" />}
          />
          <Route
            path={getRouteForActiveKey("F")}
            element={<BusinessHubSectionPage activeKey="F" />}
          />
          <Route
            path={getRouteForActiveKey("G")}
            element={<BusinessHubSectionPage activeKey="G" />}
          />
          <Route
            path={getRouteForActiveKey("I")}
            element={<BusinessHubSectionPage activeKey="I" />}
          />
          <Route
            path={getRouteForActiveKey("J")}
            element={<BusinessHubSectionPage activeKey="J" />}
          />
          <Route
            path={getRouteForActiveKey("K")}
            element={<BusinessHubSectionPage activeKey="K" />}
          />
          <Route
            path={getRouteForActiveKey("L")}
            element={<BusinessHubSectionPage activeKey="L" />}
          />
          <Route
            path={getRouteForActiveKey("M")}
            element={<BusinessHubSectionPage activeKey="M" />}
          />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/add-role" element={<AddRole />} />
          <Route path="/edit-user-details" element={<EditUserDetails />} />
          <Route path="/edit-user-roles" element={<EditUserRole />} />{" "}
          <Route path="/delivery-management" element={<DeleveryManagment />} />
          <Route
            path="/create-campaign"
            element={<LegacyPromotionRedirect />}
          />
          <Route
            path="/active-promotion"
            element={<LegacyPromotionRedirect targetView="promotion-details" />}
          />
          <Route
            path="/featured-placement"
            element={
              <LegacyPromotionRedirect targetView="featured-placement" />
            }
          />
          <Route
            path="/product-submissions"
            element={<ProductSubmissionPage />}
          />
          <Route
            path="/promotions-and-marketing"
            element={<PromotionsAndMarketingPage />}
          />
        </Routes>
      </>
    </div>
  );
}

export default App;
